import * as React from 'react';

interface IFormUpdateProxyContext {
  requestUpdate: () => void | null;
  onFieldBlur: () => void | null;
}

interface IFormUpdateProxyProvider extends IFormUpdateProxyContext {
  children: React.ReactNode;
  allowUpdate: boolean;
  allowUpdateOnFieldBlur?: boolean;
}

export const FormUpdateProxyContext = React.createContext<IFormUpdateProxyContext>(undefined!);

export function FormUpdateProxyProvider({
  children,
  requestUpdate,
  allowUpdate,
  onFieldBlur,
  allowUpdateOnFieldBlur,
}: IFormUpdateProxyProvider) {
  const formUpdateProxy = React.useMemo<IFormUpdateProxyContext>(() => ({
    requestUpdate: () => {
      if (allowUpdate && requestUpdate !== null) {
        requestUpdate();
      }
    },
    onFieldBlur: () => {
      if (allowUpdateOnFieldBlur && onFieldBlur !== null) {
        onFieldBlur();
      }
    },
  }), [allowUpdate, requestUpdate, allowUpdateOnFieldBlur, onFieldBlur]);

  return (
    <FormUpdateProxyContext.Provider value={formUpdateProxy}>
      {children}
    </FormUpdateProxyContext.Provider>
  );
}

export const useFormUpdateProxy = () => React.useContext(FormUpdateProxyContext);
